import React from "react";
import { Card, Tag, Avatar } from "antd";
import {
    BellOutlined,
    MailOutlined,
    PhoneOutlined,
} from "@ant-design/icons";
import SOURCES from "../../../../utils/constants";
import { capitalizeFirstLetter } from "../../../../utils/functions";
import { cn } from "../../../../utils/cn";
import CommonCheckbox from "../../../global/checkbox";

const AlertUserCard = ({ user, checked, onChange }) => {
    return (
        <Card
            hoverable
            onClick={() => onChange(!checked, user.id)}
            className={cn(
                "relative h-full cursor-pointer transition-all",
                checked
                    ? "!border-primary ring-1 ring-primary/40"
                    : "border-gray-200"
            )}
        >
            {/* Top Right Checkbox */}
            <div
                className="absolute top-3 right-3 z-10"
                onClick={(e) => e.stopPropagation()}
            >
                <CommonCheckbox
                    checked={checked}
                    onChange={(e) =>
                        onChange(e.target.checked, user.id)
                    }
                />
            </div>

            <div className="space-y-4">
                {/* Header */}
                <div className="flex items-start gap-3 min-w-0 pr-8">
                    <Avatar
                        size={44}
                        className="!bg-primary flex-shrink-0"
                        icon={<BellOutlined />}
                    />

                    <div className="min-w-0">
                        <h3 className="font-semibold text-sm truncate text-primary">
                            {user.alertName}
                        </h3>

                        <Tag color="cyan" className="mt-1">
                            {user.alertVia === SOURCES.ALERT_VIA_BOTH
                                ? "Email / SMS"
                                : capitalizeFirstLetter(user.alertVia)}
                        </Tag>
                    </div>
                </div>

                {/* Divider */}
                <div className="border-b border-gray-200" />

                {/* Contact Info */}
                <div className="space-y-2 text-sm text-gray-600">
                    {user.alertEmail && (
                        <div className="flex items-center gap-2 truncate">
                            <MailOutlined className="flex-shrink-0" />
                            <span className="truncate">{user.alertEmail}</span>
                        </div>
                    )}

                    {user.alertSms && (
                        <div className="flex items-center gap-2">
                            <PhoneOutlined className="flex-shrink-0" />
                            <span>{user.alertSms}</span>
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
};

export default AlertUserCard;
